var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOutlineBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 6.237C1.333 2.793 4.319 0 8 0c3.68 0 6.666 2.793 6.666 6.237 0 .783-.273 1.64-.643 2.458-.375.833-.885 1.7-1.43 2.528-1.091 1.655-2.37 3.217-3.144 4.123l-.002.002c-.747.87-2.148.87-2.895 0l-.002-.002c-.773-.905-2.053-2.468-3.143-4.123-.546-.828-1.055-1.695-1.431-2.528-.37-.818-.643-1.675-.643-2.458ZM8 1.782c-2.63 0-4.762 1.995-4.762 4.455 0 .433.161 1.03.493 1.765.324.72.78 1.503 1.297 2.286 1.014 1.54 2.215 3.012 2.972 3.9.756-.888 1.957-2.36 2.971-3.9.517-.783.973-1.567 1.298-2.286.331-.735.493-1.332.493-1.765 0-2.46-2.133-4.455-4.762-4.455Zm0 3.564a.987.987 0 0 0-.674.26.863.863 0 0 0-.279.63c0 .237.1.463.28.63A.98.98 0 0 0 8 7.128a.987.987 0 0 0 .673-.261.863.863 0 0 0 .28-.63.861.861 0 0 0-.28-.63A.987.987 0 0 0 8 5.346Zm-2.02-1A2.96 2.96 0 0 1 8 3.565a2.96 2.96 0 0 1 2.02.783c.536.5.837 1.18.837 1.89a2.59 2.59 0 0 1-.837 1.89A2.96 2.96 0 0 1 8 8.909a2.96 2.96 0 0 1-2.02-.782 2.588 2.588 0 0 1-.837-1.89c0-.71.3-1.39.836-1.89Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutlineBlackIcon);
export default __webpack_public_path__ + "static/media/location-outline-black-icon.92eb7de4b3651f4e94b48f6bc6a7bcbf.svg";
export { ForwardRef as ReactComponent };